import { Transition } from '@headlessui/react'
import { ExclamationCircleIcon, CloseIcon } from '../../icons/general.tsx'

export type NotificationItem = {
  id: string
  message: string
}

type NotificationProps = {
  notifications: NotificationItem[]
  removeNotification: (id: string) => void
}

export default function Notification({
  notifications,
  removeNotification,
}: NotificationProps) {
  return (
    <div
      aria-live="assertive"
      className="pointer-events-none fixed inset-0 flex px-4 py-6 sm:items-start sm:p-6 top-12"
    >
      <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
        {notifications.slice(0, 3).map((notification, index) => (
          <Transition
            key={notification.id}
            show={true}
            enter="transition ease-out duration-300"
            enterFrom="opacity-0 translate-y-2 sm:translate-y-0 sm:translate-x-2"
            enterTo="opacity-100 translate-y-0 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100 translate-y-0 sm:translate-x-0"
            leaveTo="opacity-0 translate-y-2 sm:translate-y-0 sm:translate-x-2"
          >
            <div
              className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
              style={{ marginTop: `${index * 16}px` }}
            >
              <div className="p-4">
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <ExclamationCircleIcon
                      aria-hidden="true"
                      className="h-5 w-5 text-red-400"
                    />
                  </div>
                  <div className="ml-3 w-0 flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      {notification.message}
                    </p>
                  </div>
                  <div className="ml-4 flex flex-shrink-0">
                    <button
                      type="button"
                      onClick={() => removeNotification(notification.id)}
                      className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CloseIcon aria-hidden="true" className="h-5 w-5" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        ))}
      </div>
    </div>
  )
}
